// -----------------------------------------------
// SNS
// -----------------------------------------------
$(function() {
  var $librarySnsBtn = $('#js-library-sns-btn'),
      $ibrarySnsList = $('#js-ibrary-sns-list');

  $librarySnsBtn.on('click', function() {
    if($(this).hasClass('is-show')) {
      $(this).removeClass('is-show');
      $ibrarySnsList.fadeOut();
    } else {
      $(this).addClass('is-show');
      $ibrarySnsList.fadeIn();
    }
  });
});

$(function() {
  var headerHight = 62;
  // #で始まるアンカーをクリックした場合に処理(.non_scrollをつけると除外)
  $('a[href^=#]' + 'a:not(.non_scroll)').click(function() {
    // スクロールの速度
    var speed = 400; // ミリ秒
    // アンカーの値取得
    var href= $(this).attr("href");
    // 移動先を取得
    var target = $(href == "#" || href == "" ? 'html' : href);
    // 移動先を数値で取得
    var position = target.offset().top - headerHight; // ※　-headerHightでズレの処理
    // スムーズスクロール
    $('body,html').animate({scrollTop:position}, speed, 'swing');
    return false;
  });
});

// amazon
(function() {
  var ua = window.navigator.userAgent.toLowerCase();
  var $bgThumb = $('.js-bg-thumb');
  var $imgThumb = $('.js-img-thumb');

  if ((ua.indexOf('msie') != -1) || (ua.indexOf('edge') != -1)) {
    /* MS IE. or MS Edge */
    $bgThumb.show();
  } else {
    /* Other. */
    $imgThumb.show();
  }
}());

// 作品画像スライドショー
(function() {
  var libraryPhotoGallery = '.js-library-photo-gallery',
      libraryPhotoGalleryPagenation ='.js-library-photo-gallery-pagenation',
      libraryPhotoGalleryPrev = '.js-library-photo-gallery-prev',
      libraryPhotoGalleryNext = '.js-library-photo-gallery-next';

  var mySwiper = new Swiper(libraryPhotoGallery, {
    width: 410,
    height: 250,
    spaceBetween: 10,
    pagination: {
      el: libraryPhotoGalleryPagenation,
      type: 'fraction',
    },
    navigation: {
      prevEl: libraryPhotoGalleryPrev,
      nextEl: libraryPhotoGalleryNext,
    },
  });
}());

/* ==========================================================================
   表のタイトルの長い文字処理
   ==========================================================================*/
(function() {
  var $setElm = $('.js-cut_txt'),
      afterTxt = ' …'; // 文字カット後に三点リーダーに置き換え
  $setElm.each(function(){
    var cutFigure = $(this).data('text-count'),
        textLength = $(this).text().length,
        textTrim = $(this).text().substr(0,(cutFigure));
    if(cutFigure < textLength) {
      $(this).html(textTrim + afterTxt).css({visibility:'visible'});
    } else if(cutFigure >= textLength) {
      $(this).css({visibility:'visible'});
    }
  });
}());

$(function(){
  var $setElm = $('.cut_txt');
  var cutFigure = '8'; // カットする全角文字数
  var afterTxt = ' …'; // 文字カット後に表示するテキスト
  var recommendList  = '.js-recommend-list',
      $recommendList = $(recommendList);

  // tile
  $recommendList.tile();

  $setElm.each(function(){
    var textLength = $(this).text().length;
    var textTrim = $(this).text().substr(0,(cutFigure))
    if(cutFigure < textLength) {
      $(this).html(textTrim + afterTxt).css({visibility:'visible'});
    } else if(cutFigure >= textLength) {
      $(this).css({visibility:'visible'});
    }
  });

  var popupParent = '.ttl td',
    $popupParent = $(popupParent),
    ttlCell = '.ttl-cell',
    $ttlCell = $(ttlCell),
    tableCage = '.table_cage',
    $tableCage = $(tableCage),
    seasonTable = '.season_table',
    $seasonTable = $(seasonTable),
    clickCount = 0,
    popup = '.popup',
    $popup = $(popup),
    popupLength = $popup.length;

  $popup.css({
    display: 'none',
  });

  if($popup.length > 7) {
    $popupParent.hover(function() {
    if ($(this).first().text().length > 26) {
      var $clone = $(this).find(popup).clone().css({
        display: 'block',
        top: $(this).offset().top - 85, //topはボタンと同じ位置
        left: $(this).offset().left + $(this).outerWidth() - 55 //leftはボタンの右側に配置
      }).fadeIn().addClass('clone');
      $("body").append($clone);
    } else {
      var $clone = $(this).find(popup).clone().css({
        display: 'block',
        top: $(this).offset().top - 55, //topはボタンと同じ位置
        left: $(this).offset().left + $(this).outerWidth() - 55 //leftはボタンの右側に配置
      }).fadeIn().addClass('clone');
      $("body").append($clone);
    }
  }, function() {
    var $clone = $(this).find(popup).clone();
    $('.clone').fadeOut().queue(function() {
      $(this).remove();
    });
  });
  } else {
    if($popup.length == 6) {
      $seasonTable.addClass('wdt100');
      $popupParent.hover(function() {
        var $clone = $(this).find(popup).clone().css({
            display: 'block',
            top: $(this).offset().top - 55, //topはボタンと同じ位置
            left: $(this).offset().left + $(this).outerWidth() - 55 //leftはボタンの右側に配置
          }).fadeIn().addClass('clone');
          $("body").append($clone);
      }, function() {
        var $clone = $(this).find(popup).clone();
        $('.clone').fadeOut().queue(function() {
          $(this).remove();
        });
      });
    } else {
      $seasonTable.addClass('wdt100');
      $popupParent.hover(function() {
        var $clone = $(this).find(popup).clone().css({
            display: 'block',
            top: $(this).offset().top - 55, //topはボタンと同じ位置
            left: $(this).offset().left + $(this).outerWidth() - 102 //leftはボタンの右側に配置
          }).fadeIn().addClass('clone');
          $("body").append($clone);
      }, function() {
        var $clone = $(this).find(popup).clone();
        $('.clone').fadeOut().queue(function() {
          $(this).remove();
        });
      });
    }
  }
});

/* ==========================================================================
   tile処理まとめ
   ==========================================================================*/
$(function() {
  $('.js-tile_title').tile(2);
  $('.js-tile_table').tile(2);
  $('.js-tile-cast').tile(2);
  $('.js-tile-recommend').tile(2);
});

/* ==========================================================================
   ツールチップ
   ==========================================================================*/
$(function(){
  $(document).on({
  "mouseenter": function() {
    $(this).find('.tooltip').stop().fadeIn();
  },
  "mouseleave": function() {
    $(this).find('.tooltip').stop().fadeOut();
  }
  }, "th.situation,td.bnr_library");
});

// photo gallery - library
$(function(){
  var photoGallery = '.js-photo-gallery',
    $photoGallery = $(photoGallery),
    photoGalleryThumbs = '.js-photo-gallery_thumbs',
    $photoGalleryThumbs = $(photoGalleryThumbs),
    photoGalleryModal = '.js-photo-gallery-modal',
    $photoGalleryModal = $(photoGalleryModal),
    photoArea = '.js-photo-area',
    $photoArea = $(photoArea),
    activeClass = 'is-active',
    prev = '.js-prev',
    $prev = $(prev),
    next = '.js-next',
    $next = $(next),
    close = '.js-close',
    $close = $(close),
    scTop;

  $photoGallery.on('click', function(e) {
    var eTarget = $(e.target);

    $photoGalleryModal.fadeIn(300);

    $('.js-tile-photo-gallery').tile(2);

    scTop = $(window).scrollTop();

    $('.cont-a-foot').css({
      position: 'fixed',
      width: '100%',
      top: -1 * scTop
    });

    $(window).off('scroll.bindScroll');
  });

  $photoGalleryModal.on('click', function(e) {
    $photoGalleryModal.fadeOut(300);
    $('.cont-a-foot').attr({style: ''});
    $('html, body').prop({scrollTop: scTop});
    scrollEvent();
  });
});

// photo gallery - library（見所ポイント）
$(function() {
  var $photoGalleryPoint = $('.js-photo-gallery-point'),
      $photoGalleryModalPoint = $('.js-photo-gallery-modal-point'),
      $photoGalleryModalPointImg = $('#js-photo-gallery-modal-point-img'),
      imgUrl, imgAlt, scTop;

  $photoGalleryPoint.on('click', function(e) {
    scTop = $(window).scrollTop();
    imgUrl = $(this).attr('data-point-img');
    imgAlt = $(this).attr('data-point-alt');

    $photoGalleryModalPointImg.attr({
      'src': imgUrl,
      'alt': imgAlt
    });

    $photoGalleryModalPoint.fadeIn(300);

    $('.cont-a-foot').css({
      position: 'fixed',
      width: '100%',
      top: -1 * scTop
    });

    $(window).off('scroll.bindScroll');
  });

  $photoGalleryModalPoint.on('click', function(e) {
    $photoGalleryModalPoint.fadeOut(300);
    $('.cont-a-foot').attr({style: ''});
    $('html, body').prop({scrollTop: scTop});
    $photoGalleryModalPointImg.removeAttr('src alt');
    scrollEvent();
  });
});

$(function(){
  var libraryModuleLink = '.js-library_module_link',
    $libraryModuleLink = $(libraryModuleLink),
    linkAction = '.js-link_action',
    $linkAction = $(linkAction),
    hostname = new RegExp(location.hostname); // あとで文字列の一致に使用するため正規表現クラスのインスタンスとして保存

  $libraryModuleLink.on('click', function(e) {
    var libraryModuleLinkData = $(this).data('library-link');
    var target = $(e.target);

    if(!target.is(linkAction)) {
      // とばしたいリンクがドメイン内なら内部遷移、外部リンクなら別タブで表示
      if (hostname.test(libraryModuleLinkData)) {
        location.href = libraryModuleLinkData;
      } else {
        window.open(libraryModuleLinkData, '_blank');
      }
    }
  });
});

$(function(){
  var inputCkecked = '.js-input_checked',
    $inputCkecked = $(inputCkecked),
    radioBox = '.js-radio_box',
    $radioBox = $(radioBox),
    reviewVal = '.js-review_val',
    $reviewVal = $(reviewVal),
    reviewModalBtn = '.js-review_modal_btn',
    $reviewModalBtn = $(reviewModalBtn)
    revireModal = '.js-review_modal',
    $revireModal = $(revireModal);

  var scTop;

  $reviewModalBtn.on('click', function(e) {
    if (!$(this).hasClass('disabled')) {
      scTop = $(window).scrollTop();
      $revireModal.fadeIn();
      $('.cont-a-foot').css({
        position: 'fixed',
        width: '100%',
        top: -1 * scTop
      });
      $(window).off('scroll.bindScroll');
    } else {
      e.preventDefault();
    }
  });

  $revireModal.on('click', function(e) {
    var eTarget = $(e.target);

    if (eTarget.hasClass('js-close')) {
      $revireModal.fadeOut();
      $('.cont-a-foot').attr({style: ''});
      $('html, body').prop({scrollTop: scTop});
      scrollEvent();
    }
  });

  $inputCkecked.on('click', function() {
    var inputType = $(this).attr('type');

    if (inputType == 'radio') {
      $(this).parents(radioBox).children().removeClass("is-active");
      if($(this).val() =="1") {
        $(this).parents(radioBox).children(".check01").addClass("is-active");
        $(this).parents(radioBox).children(".check01").children('input').prop("checked", !0);
      } else if($(this).val() =="2") {
        $(this).parents(radioBox).children(".check01,.check02").addClass("is-active");
        $(this).parents(radioBox).children(".check02").children('input').prop("checked", !0);
      } else if($(this).val() =="3") {
        $(this).parents(radioBox).children(".check01,.check02,.check03").addClass("is-active");
        $(this).parents(radioBox).children(".check3").children('input').prop("checked", !0);
      } else if($(this).val() =="4") {
        $(this).parents(radioBox).children(".check01,.check02,.check03,.check04").addClass("is-active");
        $(this).parents(radioBox).children(".check04").children('input').prop("checked", !0);
      } else if($(this).val() =="5") {
        $(this).parents(radioBox).children().addClass("is-active");
        $(this).parents(radioBox).children(".check05").children('input').prop("checked", !0);
      }

      $reviewVal.text($(this).val() + '.0');
    } else {
      $(this).parent().toggleClass('is-active');
    }
  });

  $radioBox.children('label').hover(function () {
    var index = $radioBox.children('label').index(this) + 1;
    $radioBox.children('label').removeClass("is-active");
    if(index =="1") {
      $(".check01").addClass("is-active");
      $(".check01").children('input').prop("checked", !0);
    } else if(index =="2") {
      $(".check01,.check02").addClass("is-active");
      $(".check02").children('input').prop("checked", !0);
    } else if(index =="3") {
      $(".check01,.check02,.check03").addClass("is-active");
      $(".check3").children('input').prop("checked", !0);
    } else if(index =="4") {
      $(".check01,.check02,.check03,.check04").addClass("is-active");
      $(".check04").children('input').prop("checked", !0);
    } else if(index =="5") {
      $radioBox.children('label').addClass("is-active");
      $(".check05").children('input').prop("checked", !0);
    }
    $reviewVal.text(index + '.0');
  });
});

$(function(){
  if($('#myChart').length) {
    var ctx = document.getElementById("myChart").getContext("2d");
    ctx.canvas.height = 100;
    new Chart(ctx, {
      type: 'bar',
        data: {
          labels: ["星：1", "星：2", "星：3", "星：4", "星：5"],
        datasets: [{
          label: 'レビュー数 ',
          data: chartData,
          fillColor: "#ddd",
          backgroundColor: "rgba(255, 212, 0, 0.4)",
          borderColor: "#eda213",
          borderWidth: 1,
          bezierCurve: false,
        }]
      }, options: {
        legend: {
          labels: {
            boxWidth:30,
            padding:20
          },
          display: false
        },
        scales: {
          xAxes: [{
            stacked: true,
            categoryPercentage: .35,
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              min: 0,
              max: chartMax,
              stepSize: stepSize,
            }
          }]
        }
      }
    });
  }
});

// Fixed Cv Btn
// $(function() {
//   var $fixedCvr = $('.js-fixed_cvr'),
//       fixedCvrHeight = $fixedCvr.innerHeight(),
//       $target = $('.js-hide_btn_target');

//   $target.on('inview', function(e, isInView) {
//     if(isInView) {
//       $fixedCvr.css({bottom: '-' + fixedCvrHeight + 'px'});
//     } else {
//       $fixedCvr.css({bottom: '0'});
//     }
//   });
// });

$(function() {
  var $chartObjList = $('.js-brand-point-score-chart');
  if($chartObjList.length) {    
    $chartObjList.each(function(index, chartObj) {
      var canvas = chartObj.getContext("2d");
      var $chartObj = $(chartObj);
      var chartLabels = $chartObj.data('chart-labels');
      var chartDatas = $chartObj.data('chart-datas');
      var chartObjHeight = $chartObj.closest('div').height

      new Chart(canvas, {
        type: 'radar',
        data: {
          labels: chartLabels,
          datasets: [{
            data: chartDatas,
            borderColor: '#757de0',
            backgroundColor: [
              'rgba(229, 231, 250, 0.6)',
            ],
            lineTension: 0.2,
          }],
        },
        options: {
          layout: {
          },
          // 親要素いっぱいに表示
          maintainAspectRatio: false,
          scale: {
            ticks: {
              display: false,
              max: 5,
              min: 0,
              stepSize: 1,
              scaleLabel: {
                display: false,
              },
            },
            pointLabels: {
              fontColor: '#757de0',
              fontSize: 10,
              fontStyle: 'bold',
            },
            angleLines: {
              color: '#e5e7fa',
              borderDash: [8, 8]
            },
            gridLines: {
              circular: true,
              // color: '#e5e7fa',
              color: [
                'rgba(229, 231, 250, 0.2)',
                'rgba(229, 231, 250, 0.4)',
                'rgba(229, 231, 250, 0.6)',
                'rgba(229, 231, 250, 0.8)',
                'rgba(229, 231, 250, 1)',
              ],
              lineWidth: 2,
            },
          },
          legend: {
            display: false,
            labels: {
              fontSize: 10,
              fontStyle: 'bold',
              fontColor: '#757de0',
            },
          }
        }
      });
    });
  }
});